import React from "react";
import Container from "./container";
import BoiReactMarkdown from "../../boi-markdown/boi-markdown";
import { replaceMergeTagsInString } from "../helper";

const Html = props => (
    <Container {...props}>
        <BoiReactMarkdown>
            {replaceMergeTagsInString(props.content, props.context.getValues())}
        </BoiReactMarkdown>
    </Container>
);
Html.defaultProps = {
    context: { getValues: () => ({}) }
};

export default Html;
